import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CloseBlue } from '$icons/CloseBlue.svg';
import { ReactComponent as ArrowRight } from '$icons/ArrowRight.svg';
import {
  candidatesApi,
  useUpdateCandidatePositionStatusToOfferSentMutation,
} from '../../../../../../store/modules/candidates';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks';
import { companiesApi } from '../../../../../../store/modules/companies';
import { segmentTrack } from '../../../../../../utils/handleSegment';

type Props = {
  handleClose: (show: boolean) => void;
  candidatePositionStatusId: number;
  candidateId: number;
  setSwitchingId: (candidateId: number) => void;
};

const MakeOfferConfirmModalContent: FC<Props> = ({
  handleClose,
  candidatePositionStatusId,
  candidateId,
  setSwitchingId,
}) => {
  const [t, i18n] = useTranslation('global');
  const { serverUser } = useAppSelector((state: any) => state.auth);
  const [updateCandidatePositionStatusToOfferSentAsCandidate] =
    useUpdateCandidatePositionStatusToOfferSentMutation();
  const dispatch = useAppDispatch();

  const handleConfirm = async () => {
    await updateCandidatePositionStatusToOfferSentAsCandidate({
      data: {
        candidatePositionStatusId,
        user: {
          name: `${serverUser?.FirstName} ${serverUser?.LastName}`,
          email: serverUser?.Email!,
        },
      },
      lang: i18n.language as 'en' | 'es',
    }).then(() => {
      setSwitchingId(candidateId);
      dispatch(candidatesApi.util.invalidateTags(['Candidates']));
      dispatch(companiesApi.util.invalidateTags(['PositionsList']));
      segmentTrack('Make Offer', {
        candidate_id: candidateId,
      });
      handleClose(false);
    });
  };

  return (
    <div className="bg-white w-[calc(100%-40px)] sm:w-[600px] font-sans mt-auto mb-5 sm:mb-auto">
      <div className="flex justify-between items-center gap-2 border-b-[1px] border-[#E6F0F4] p-6 pb-[17px]">
        <h1 className="text-lg sm:text-[20px] font-semibold text-center sm:text-start">
          {t('MakeOfferConfirmModal.ConfirmTitle')}
        </h1>
        <CloseBlue
          onClick={() => handleClose(false)}
          className="hidden sm:block cursor-pointer w-12 h-12 sm:w-6 sm:h-6"
        />
      </div>
      <div className="p-6 items-center flex flex-col gap-8 w-full">
        <div className="flex gap-4 flex-col sm:flex-row items-center">
          <p>{t('MakeOfferConfirmModal.ComfirmText')}</p>
        </div>
        <div className="flex gap-4 justify-end w-full flex-col-reverse sm:flex-row">
          <button
            type="button"
            className="h-12 px-4 font-semibold text-brand-blue100"
            onClick={() => handleClose(false)}
          >
            {t('MakeOfferConfirmModal.ConfirmBack')}
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="h-12 rounded font-semibold text-white flex justify-center items-center gap-2 px-4 bg-brand-blue100"
          >
            <p>{t('MakeOfferConfirmModal.ConfirmButton')}</p>
            <ArrowRight className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MakeOfferConfirmModalContent;
